module.exports = __webpack_public_path__ + "681bcd4b68f60b4ded31e971ca3ed9d2.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AI.svg
// module id = dVR/
// module chunks = 0